import { render, staticRenderFns } from "./reviewReport.vue?vue&type=template&id=dee5f9fa&scoped=true&"
import script from "./reviewReport.vue?vue&type=script&lang=js&"
export * from "./reviewReport.vue?vue&type=script&lang=js&"
import style0 from "./reviewReport.vue?vue&type=style&index=0&id=dee5f9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee5f9fa",
  null
  
)

export default component.exports